import React from "react";
import { Header, Loading, Share } from "../../components";
import { useStateContext } from "../../contexts/ContextProvider";
import { useSelector } from "react-redux";
import { user, userId } from "../../redux/reducers/userReducer";
import { useState } from "react";
import { useEffect } from "react";
import {
  collection,
  orderBy,
  query,
  doc,
  getDoc,
  updateDoc,
  writeBatch,
  onSnapshot,
} from "firebase/firestore";
import Swal from "sweetalert2";
import { db } from "../../firebase";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { AiOutlineCopy } from "react-icons/ai";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Referral = () => {
  const { activeMenu } = useStateContext();
  const currentUser = useSelector(user);
  const currentUserID = useSelector(userId);
  const [card, setCard] = useState([]);
  const [isClicked, setIsClicked] = useState(false);
  const [loading, setLoading] = useState(false);
  const [referredNumber, setReferredNumber] = useState("");

  //Fetch the referredNumber from the db using the currentUSerID from collection /users/userProfiles/AllUsers
  useEffect(() => {
    const documentRef = doc(db, "/users/userProfiles/AllUsers", currentUserID);
    const unsubscribe = onSnapshot(documentRef, (docSnap) => {
      if (docSnap.exists()) {
        const data = docSnap.data();
        const referredno = data.referredNumber;
        setReferredNumber(referredno);
      } else {
        console.log("document error");
      }
    });

    return () => unsubscribe();
  }, [currentUserID]);

  //Fetch referral card from collection usergiftcards and then subcollection using currentuser email
  useEffect(() => {
    const fetchReferralCard = async () => {
      const documentRef = doc(db, "users", "userGiftcards");
      const documentSnap = await getDoc(documentRef);
      if (documentSnap.exists()) {
        const subcollectionRef = collection(documentRef, currentUser.email);
        const q = query(subcollectionRef, orderBy("id", "asc"));
        onSnapshot(q, (response) => {
          setLoading(true);
          const data = response.docs.map((doc) => ({
            ...doc.data(),
          }));

          // changing the format of endDate as 1,2,3...
          const currentDate = new Date();
          const updatedData = data.map((card) => {
            const endDateTimestamp =
              card.endDate.seconds * 1000 + card.endDate.nanoseconds / 1000000;
            const endDateDate = new Date(endDateTimestamp);
            const timeDiff = endDateDate.getTime() - currentDate.getTime();
            const remainingDays = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));

            return {
              ...card,
              endDate: remainingDays,
            };
          });
          setCard(updatedData);

          // checking if any card is expired or not if expired it will update in db
          const expiredCards = updatedData.filter((card) => card.endDate <= 0);
          if (expiredCards.length > 0) {
            const batch = writeBatch(db);
            expiredCards.forEach((card) => {
              const cardRef = doc(subcollectionRef, card.docID);
              batch.update(cardRef, { isExpired: true });
            });
            batch.commit();
          }
        });
      }
    };
    fetchReferralCard();
  }, [currentUser.email]);

  // Function to redeem the gift card
  const redeemCode = async (id) => {
    const startDate = new Date();
    const endDate = new Date();
    endDate.setDate(endDate.getDate() + 30);
    try {
      const documentRef = doc(db, "users", "userGiftcards");
      const documentSnap = await getDoc(documentRef);
      if (documentSnap.exists()) {
        const subcollectionRef = collection(documentRef, currentUser.email);
        const cardRef = doc(subcollectionRef, id);
        await updateDoc(cardRef, {
          isActive: true,
          startDate: startDate,
          endDate: endDate,
        }).then(() => {
          toast.success("Redeemed Successfully", {
            position: "top-right",
            theme: "light",
            toastId: "redeemsuccess",
          });
        });
      } else {
        console.log("document doesnt exist");
      }
    } catch (err) {
      console.log("error", err);
      console.log("error while redeeming gift card");
    }
  };

  // function to give warning before activating the card
  const handleWarning = (isactive, code, id) => {
    if (isactive) {
      console.log("already active");
      Swal.fire({
        text: `Your Redeem code : ${code}`,
        confirmButtonText: "Claim now",
        showConfirmButton: true,
        confirmButtonColor: "#116C6E",
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire({
            title: "Alert",
            icon: "warning",
            html: `<p>Once you click yes you card will expire, Are you sure you want to claim ?</p>`,
            confirmButtonText: "Yes",
            showConfirmButton: true,
            showCloseButton: true,
            confirmButtonColor: "#116C6E",
          }).then(async (result) => {
            if (result.isConfirmed) {
              const documentRef = doc(db, "users", "userGiftcards");
              const documentSnap = await getDoc(documentRef);
              if (documentSnap.exists()) {
                const subcollectionRef = collection(
                  documentRef,
                  currentUser.email
                );
                const cardRef = doc(subcollectionRef, id);
                await updateDoc(cardRef, {
                  isExpired: true,
                });
              }
            }
          });
        }
      });
    } else {
      Swal.fire({
        title: "Warning",
        text: "Once you proceed, your card will be activated.",
        icon: "warning",
        confirmButtonText: "Proceed",
        showConfirmButton: true,
        showCancelButton: true,
        cancelButtonText: "Cancel",
        confirmButtonColor: "#116C6E",
      }).then((result) => {
        if (result.isConfirmed) {
          redeemCode(id);
        }
      });
    }
  };

  // Function to copy the referral code using react-copyto-clipboard library
  const handleCopy = () => {
    toast.success(`Referral Code ${currentUserID} copied`, {
      position: "top-right",
      theme: "light",
      toastId: "referralcopied",
    });
  };

  return (
    <div className="mt-20 md:mt-10 mx-3">
      <Header title="Referrals" />
      <div className="bg-secondary-bg p-3 md:p-6 mt-10 rounded-sm text-gray-700  md:mx-5 mb-5">
        <span className="font-semibold  text-lg flex justify-center">
          Refer a Friend and Earn a Gift Card
        </span>
        <div className="mt-4 flex flex-col gap-4">
          <span className="font-semibold">How It Works :</span>
          <p className="text-sm font-medium">
            1. Share your unique referral link with friends through email,
            social media, or direct messaging.
          </p>
          <p className="text-sm font-medium">
            2. Your friend signs up using your referral link or code during
            their registration.
          </p>
          <p className="text-sm font-medium">
            3. Once your friend completes their Sign up , they receive a $50
            Off, and you'll also get a $50 discount for your next order.
          </p>
          <p className="text-sm font-medium">
            4. Use the redeem code at your nearest Bitcare Medspa and Wellness
            center to get the discount.
          </p>
        </div>
        <div className="mt-10 text-lg font-bold">
          <span>Referral Points: </span>
          <span>{referredNumber}</span>
        </div>
        <div className="mt-5 text-lg font-bold md:flex items-center gap-4">
          <span>Your Referral Code: </span>
          <CopyToClipboard text={currentUserID} onCopy={handleCopy}>
            <span className="text-sm font-semibold cursor-pointer border-2 border-gray-500 rounded-lg p-2 flex gap-2 mt-4 md:mt-0 items-center w-fit">
              <p>
                <AiOutlineCopy size={24} />
              </p>
              {currentUserID}
            </span>
          </CopyToClipboard>
        </div>
        {loading ? (
          <div
            className={`mt-6 grid gap-4 xl:grid-cols-2 lg:grid-cols-2
            md:grid-cols-2 ${activeMenu ? "md:grid-cols-1" : ""}
        `}
          >
            {card?.map((item) => (
              <div
                key={item.docID}
                className={`flex flex-col gap-4 relative rounded-md shadow
                   ${
                     item.id === 1 &&
                     (item.isExpired
                       ? "bg-gradient-to-r from-[#fde4cf] to-[#cfbaf0] grayscale"
                       : "bg-gradient-to-r from-[#fde4cf] to-[#cfbaf0]")
                   }
                   ${
                     item.id === 2 &&
                     (item.isExpired
                       ? "blur-sm bg-gradient-to-r from-[#8eecf5] to-[#b9fbc0] grayscale"
                       : "bg-gradient-to-r from-[#8eecf5] to-[#b9fbc0]")
                   }
                   ${
                     item.id === 3 &&
                     (item.isExpired
                       ? "blur-sm bg-gradient-to-r from-[#ffc8dd] to-[#ffe14c] grayscale"
                       : "bg-gradient-to-r from-[#ffc8dd] to-[#ffe14c]")
                   }
                   ${
                     item.id === 4 &&
                     (item.isExpired
                       ? "blur-sm bg-gradient-to-r from-[#6a9fb8] to-[#b9aeb8] grayscale"
                       : "bg-gradient-to-r from-[#6a9fb8] to-[#b9aeb8]")
                   }
                  ${
                    item.id === 5 &&
                    (item.isExpired
                      ? "blur-sm bg-gradient-to-r from-[#91dfaa] to-[#dbaddf] grayscale"
                      : "bg-gradient-to-r from-[#91dfaa] to-[#dbaddf]")
                  }
                     
                   }
              
              `}
              >
                {item.isExpired && (
                  <div className="absolute backdrop-blur-lg backdrop-brightness-50 w-full p-4 top-1/2 text-center z-20">
                    <p className="text-lg font-bold">Expired</p>
                  </div>
                )}
                <div className="relative">
                  <p className="text-lg font-bold flex justify-center p-2">
                    {item.toEarn}
                  </p>

                  <div
                    className={`lg:flex gap-4 justify-center ${
                      activeMenu ? "lg:flex-col xl:flex-row" : ""
                    } ${item.isActive ? "" : "blur-sm"}`}
                  >
                    <div className="flex justify-center items-center">
                      <img
                        src="./assets/giftbox.png"
                        alt="gitbox"
                        className="w-40"
                      />
                    </div>
                    <div
                      className={`p-4 flex flex-col gap-1 justify-center items-center
                  `}
                    >
                      <p className="text-lg font-bold">{item.title}</p>
                      <p className="font-semibold">{item.referralPrice}</p>
                      <p className="text-sm font-medium text-center">
                        {item.referralDisclaimer}
                      </p>
                    </div>
                  </div>
                  {!item.isExpired && (
                    <div className="m-2">
                      {item.referralNumber <= referredNumber ? (
                        <>
                          <div
                            onClick={() =>
                              handleWarning(
                                item.isActive,
                                item.secretCode,
                                item.docID
                              )
                            }
                            className="border-2  border-gray-700 rounded-lg text-center p-2 mt-2 cursor-pointer text-sm font-semibold hover:shadow-md"
                          >
                            {item.isActive ? (
                              <span>Show Code</span>
                            ) : (
                              <span>Click to Redeem Code</span>
                            )}
                          </div>
                          {/* condition to show expire days left */}
                          {item.isActive && (
                            <div className="mt-4 flex justify-center">
                              {item.endDate && (
                                <span className="font-semibold p-2">
                                  Expires in : {item.endDate} Days
                                </span>
                              )}
                            </div>
                          )}
                        </>
                      ) : (
                        <div
                          onClick={() => setIsClicked(true)}
                          className="border-2 border-gray-700 rounded-lg text-center p-2 mt-2 cursor-pointer text-sm font-semibold hover:shadow-md"
                        >
                          Refer a friend to redeem Gift Card
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        ) : (
          <Loading />
        )}
        {isClicked && <Share setIsClicked={setIsClicked} />}
      </div>
    </div>
  );
};

export default Referral;

/**
 
**Documentation: Referral Component

The Referral component represents the page where users can view their referral information and gift card rewards. 
Users can refer friends to earn gift cards, view their referral points, and redeem earned gift cards.

**Dependencies:
* react: The core library for building user interfaces in React applications.
* react-redux: The official React bindings for Redux.
* firebase: A backend-as-a-service platform that allows developers to build web and mobile applications without managing servers.
* sweetalert2: A JavaScript library for displaying custom alert messages.
* react-copy-to-clipboard: A React component that enables copying text to the clipboard.
* react-toastify: A popular library for displaying toast messages in React applications.

**State Variables:
activeMenu: Holds the current state of the active menu.
currentUser: Holds the user data obtained from the Redux store.
currentUserID: Holds the user ID obtained from the Redux store.
card: An array state variable that stores gift card data fetched from the Firebase collection.
isClicked: A boolean state variable that determines whether the share component is open or not.
loading: A boolean state variable that determines whether the referral card data is being loaded or not.
referredNumber: Holds the number of referral points earned by the user.

**Hooks:
useEffect: A hook that runs side effects in functional components. It is used to fetch referral card data and the number of referral points earned by the user.
useState: A hook that allows adding state to functional components.

**Component Structure:
1 The component fetches the user's referral points from the Firebase document users/userProfiles/AllUsers using the useEffect hook.
2. The component fetches referral card data from the Firebase collection userGiftcards and then the subcollection using the user's email. 
 It updates the card state with the fetched data. The useEffect hook also checks if any cards are expired and updates their status in the database.
3. The component includes a function redeemCode to redeem a gift card by updating the card's status to active with a start date and an end date of 30 days from the current date.
4. The component includes a function handleWarning that displays a warning message before activating a gift card. If the gift card is already active, the user is prompted to confirm that they want to claim it. If the gift card is not active, the user is warned that activating the card will expire it.
5. The component includes a function handleCopy to copy the user's referral code to the clipboard using the react-copy-to-clipboard library.
6. The component renders referral information, including how the referral system works, the user's referral points, and their referral code.
7. The component renders gift card details in a grid layout. Each gift card displays its title, referral price, and referral disclaimer. If the gift card is not expired, the user can redeem it or view the code if already redeemed. If the gift card is expired, it is displayed as blurred with an "Expired" label.
8. If the loading state is true, the component renders the gift cards; otherwise, it renders a loading indicator.
9. If the isClicked state is true, the Share component is rendered. The Share component allows the user to refer friends to earn gift cards.


**Rendered Output:
The component renders a page that displays referral information, including how the referral system works, 
the user's referral points, and their referral code. It also renders gift card details in a grid layout, 
showing details such as the title, referral price, and referral disclaimer. If the gift card is not expired, 
the user can redeem it or view the code if already redeemed. If the gift card is expired, 
it is displayed as blurred with an "Expired" label.

 */
